import React from 'react'
import {Link} from "react-router-dom";

const HeaderDropDown =(props)=> {
        return (
            <div className='header-drop-down'>
                <ul className='header-drop-down'>
                    <li>
                        <Link to="/auth/login">LogIn</Link>
                    </li>
                </ul>
            </div>
        )

};

export default HeaderDropDown;
